import React from "react";
import {
    Container,
    Grid,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import i18next from "i18next";
import InvoicesExpensesForm from "./InvoicesExpensesForm";
import InvoicesExpensesTable from "./InvoicesExpensesTable";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: "#d3d3d3",
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: "#d3d3d3",
        borderColor: "#808080",
    },
}));

export default function InvoicesExpenses(props) {
    const {AutoOptions,
        expenseList,
        setExpenseList,
         or, isOpenUpdate,
        gets,setConfirmDialog
    } = props;

    const valuePramsSub = {
        no: 0,
        id: "",
        proc_id:"",
        Expense_Acc_no: "",
        acc_no:"",
        Expense_value: "",
        Expense_Note: "",
        omla: 1,
        omlaval: 1,
        omlaName: gets.omlats[0].name,
        exchange: gets.omlats[0].exchange,
        Expense_value_Bill: "",
        Tax_Type: -1,
        acc_name:"",
        name:"",
        editOmla: false,
        edit_acc_no: false,
        editNotes: false,
        editValue: false,
        defAcc_no: {},
        defOmla: {},
    };


    const valueAutoSub = {
        Expense_Acc_no: {},
        omla: gets.omlats[0]
    };
    const [paramsSub, setParamsSub] = React.useState(valuePramsSub);

    const [paramsAutoSub, setParamsAutoSub] = React.useState(valueAutoSub);
    const classes = useStyles();
    const onChangeSub = (propName) => (event) => {
        if (propName == "omlaval") {
            let omlaVal = Number(event.target.value) == 0 ? 1 : Number(event.target.value);
            setParamsSub({ ...paramsSub, [propName]: omlaVal });
        }else if (propName == "Expense_value") {
            let omlaVal = Number(paramsSub.omlaval) == 0 ? 1 : Number(paramsSub.omlaval);
            let tot_bill = Number(event.target.value) * Number(omlaVal);
            setParamsSub({ ...paramsSub, [propName]: event.target.value, Expense_value_Bill:tot_bill});
        } 
         else {
            setParamsSub({ ...paramsSub, [propName]: event.target.value });
        }
    };

    const onChangeAutoSub = (propName, newValue) => {
        if (propName === "Expense_Acc_no") {
            setParamsAutoSub({ ...paramsAutoSub, [propName]: newValue });
            setParamsSub({ ...paramsSub, [propName]: newValue.id,acc_no:newValue.id, acc_name: newValue.name, name: newValue.name });
        } else if (propName === "omla") {
            let omlaVal = newValue.exchange == "" || newValue.exchange == 0 ? 1 : newValue.exchange;
            setParamsAutoSub({ ...paramsAutoSub, [propName]: newValue });
            setParamsSub({
                ...paramsSub, [propName]: newValue.id, omlaval: omlaVal,
                omlaName: newValue.name, exchange: newValue.exchange
            });
        } else {
            setParamsAutoSub({ ...paramsAutoSub, [propName]: newValue });
            setParamsSub({ ...paramsSub, [propName]: newValue.id });
        }
    };

    const onSubmit = (e) => {
        e.preventDefault();
        let newData = {
            ...paramsSub,
            acc_no:paramsSub.Expense_Acc_no,
            Expense_value: Number(paramsSub.Expense_value),
            Expense_value_Bill: Number(paramsSub.Expense_value_Bill),
            no: expenseList.length,
        };
        if (paramsSub.Expense_Acc_no==""|| paramsSub.Expense_Acc_no==null){
            alert("برجاء اختيار حساب");
        }else if (paramsSub.Expense_value==""|| paramsSub.Expense_value==0){
            alert("برجاء ادخال قيمة....");
        }else{
            setExpenseList([...expenseList, newData]);
            setParamsAutoSub({ ...valueAutoSub })
            setParamsSub({ ...valuePramsSub })
        }
       
    };

    return (
        <div className={classes.root}>

            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >

                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                        paddingBottom: "0px",
                        borderBottomColor: "#808080",
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                        marginTop: "0.5rem"
                    }}
                >
                    <InvoicesExpensesForm
                        {...{
                            onChangeSub,
                            onChangeAutoSub,
                            paramsAutoSub,
                            AutoOptions,
                            onSubmit,
                            paramsSub,
                            gets
                        }}
                    />

                </Container>
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        paddingRight: "5px",
                        paddingLeft: "5px",
                        paddingBottom: "0px",
                        borderBottomColor: "#808080",
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                        marginTop: "0.5rem"
                    }}
                >
                    <Grid container justifyContent="center">
                        <Grid item container justifyContent="center" xs={12}>
                            <InvoicesExpensesTable
                                {...{
                                    expenseList, setExpenseList, AutoOptions,
                                    or,isOpenUpdate,gets,setConfirmDialog,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Container>

            </Typography>


        </div>
    );
}
